import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { RefObject, useRef } from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Slider from '@unlikelystudio/react-slider'

import { useStyle } from '~/providers/StyleProvider'

import useLocale from '~/hooks/useLocale'

import { SEARCH } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type UrlParamsProps = {
  q?: string
}

export interface SearchKeysProps {
  className?: string
  inputRef?: RefObject<HTMLInputElement>
  keywords?: string[]
}

function SearchKeys({ className, keywords }: SearchKeysProps) {
  const router = useRouter()
  const locale = useLocale()
  const t = useTranslate()

  const applyKeywordAsSearch = (val: string) => {
    router.push(
      {
        pathname: router.pathname,
        query: {
          q: val,
        },
      },
      null,
      {
        shallow: true,
        locale,
      },
    )
  }

  const customSliderRef = useRef(null)

  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label18Primary,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const keywordStyle = useStyle({
    textPreset: GlobalTextPreset.Text16Secondary,
  })

  return (
    <div className={cx(css.SearchKeys, className)} ref={customSliderRef}>
      <h3 className={cx(css.title, titleStyle)}>{t(SEARCH.SUGGESTIONS)}</h3>
      <div className={cx(css.sliderContainer, css.hideOnSmallScreen)}>
        {keywords?.length > 0 && (
          <Slider
            className={cx(css.slider)}
            snap={true}
            customSliderRef={customSliderRef}
            autoBlockSlideIndexChange>
            {keywords?.map((key, i) => (
              <div
                key={i}
                className={cx(css.item, keywordStyle)}
                onClick={() => applyKeywordAsSearch(key)}>
                {key}
              </div>
            ))}
          </Slider>
        )}
      </div>
      <div className={cx(css.mobileContainer, css.hideOnLargeScreen)}>
        {keywords?.map((key, i) => (
          <div
            key={i}
            className={cx(css.item, keywordStyle)}
            onClick={() => applyKeywordAsSearch(key)}>
            {key}
          </div>
        ))}
      </div>
    </div>
  )
}

SearchKeys.defaultProps = {}

export default SearchKeys
